module.exports = __webpack_public_path__ + "static/pinkbunnymain-886706216004ace44310d00a22a968bd.png";